webpackJsonp([201276295743644],{

/***/ 1615:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _formik = __webpack_require__(10);
	
	var _yup = __webpack_require__(13);
	
	var Yup = _interopRequireWildcard(_yup);
	
	var _Alert = __webpack_require__(14);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _CheckboxGroup = __webpack_require__(17);
	
	var _CheckboxGroup2 = _interopRequireDefault(_CheckboxGroup);
	
	var _Input = __webpack_require__(9);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _RadioGroup = __webpack_require__(16);
	
	var _RadioGroup2 = _interopRequireDefault(_RadioGroup);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Datetime = __webpack_require__(18);
	
	var _Datetime2 = _interopRequireDefault(_Datetime);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SignUpFormCovid = function (_Component) {
	  _inherits(SignUpFormCovid, _Component);
	
	  function SignUpFormCovid(props) {
	    _classCallCheck(this, SignUpFormCovid);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      formState: null
	    };
	    return _this;
	  }
	
	  SignUpFormCovid.prototype.render = function render() {
	    var _this2 = this;
	
	    var formState = this.state.formState;
	    var _props = this.props,
	        classes = _props.classes,
	        className = _props.className;
	
	
	    var valid = function valid(current) {
	      return current.day() !== 0 && current.day() !== 6;
	    };
	
	    var renderDay = function renderDay(props, currentDate, selectedDate) {
	      if (currentDate.month() == (0, _moment2.default)().month()) {
	        if (currentDate.date() < (0, _moment2.default)().date()) {
	          if (props.className == "rdtDay") {
	            props.className = "rdtDay rdtDisabled";
	          }
	        }
	      }
	      if (currentDate.month() < (0, _moment2.default)().month()) {
	        props.className = "rdtDay rdtDisabled";
	      }
	
	      return _react2.default.createElement(
	        "td",
	        props,
	        currentDate.date()
	      );
	    };
	
	    if (formState === "success") {
	      return _react2.default.createElement(
	        "div",
	        {
	          style: {
	            maxWidth: "400px",
	            textAlign: "center",
	            margin: "24px auto"
	          }
	        },
	        _react2.default.createElement(
	          _Alert2.default,
	          { color: "success" },
	          _react2.default.createElement(
	            _Typography2.default,
	            { type: "heading3", gutterBottom: true },
	            "AWESOME."
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            { type: "heading6", gutterBottom: true },
	            "An Elevate sales representative will be in touch with you shortly."
	          )
	        )
	      );
	    } else if (formState === "error") {
	      return _react2.default.createElement(
	        "div",
	        { style: { maxWidth: "400px", margin: "24px auto" } },
	        _react2.default.createElement(
	          _Alert2.default,
	          { color: "error" },
	          "An error occurred."
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      "div",
	      { className: (0, _classnames2.default)(classes.root, className) },
	      _react2.default.createElement(_formik.Formik, {
	        initialValues: {
	          firstname: "",
	          lastname: "",
	          company: "",
	          email: "",
	          phone: "",
	          role: "",
	          roleOther: "",
	          interests: [],
	          form: "covidshift",
	          list: 97842
	        },
	        validationSchema: function validationSchema() {
	          return Yup.object().shape({
	            firstname: Yup.string().required("First name is required"),
	            lastname: Yup.string().required("Last name is required"),
	            company: Yup.string(),
	            email: Yup.string().email("Invalid email address").required("Email is required"),
	            phone: Yup.string().required("Phone is required"),
	            role: Yup.string(),
	            roleOther: Yup.string(),
	            interests: Yup.array()
	          });
	        },
	        onSubmit: function onSubmit(values, _ref) {
	          var setSubmitting = _ref.setSubmitting;
	
	          var meeting_request = "";
	          Object.keys(values).forEach(function (key, index) {
	            // key: the name of the object key
	            // index: the ordinal position of the key within the object
	            if (key == "meetingdate") {
	              if (typeof values.meetingdate.format === "function") {
	                meeting_request = values.meetingdate.format("YYYY-MM-DD") + "T" + values.meetingtime.replace(" (EDT)", "") + "-04:00";
	              }
	            }
	          });
	          var body = _extends({}, values, {
	            roleOther: values.role === "Other" ? values.roleOther : "", // Just in case the user had typed in roleOther then changed their role to something else
	            interestStr: values.interests.join(",") + ", Interested Markets: " + values.market1 + ", " + values.market2 + "," + values.market3,
	            utm_campaign: window.utm_tags ? window.utm_tags.campaign : "",
	            utm_source: window.utm_tags ? window.utm_tags.source : "",
	            utm_medium: window.utm_tags ? window.utm_tags.medium : "",
	            utm_term: window.utm_tags ? window.utm_tags.term : "",
	            demo_request_date: meeting_request
	          });
	          return fetch("https://hooks.zapier.com/hooks/catch/4496703/3uy9gh0/", {
	            method: "POST",
	            body: JSON.stringify(body)
	          }).then(function (response) {
	            return response.json();
	          }).then(function (res) {
	            if (res.status === "success") {
	              _this2.setState({ formState: "success" });
	              dataLayer.push({ event: "form-success" });
	
	              if (window.fbq) {
	                window.fbq("track", "Lead");
	              }
	              if (window.gtag) {
	                window.gtag("event", "conversion", {
	                  send_to: "AW-980447970/2_aHCOnsjo8BEOLlwdMD"
	                });
	              }
	              if (window.ga) {
	                window.ga("send", "event", "form", "form_completed", "get-started");
	              }
	            } else {
	              _this2.setState({ formState: "error" });
	            }
	          }).catch(function (err) {
	            _this2.setState({ formState: "error" });
	          });
	        },
	        render: function render(_ref2) {
	          var values = _ref2.values,
	              isSubmitting = _ref2.isSubmitting,
	              handleBlur = _ref2.handleBlur,
	              handleChange = _ref2.handleChange;
	          return _react2.default.createElement(
	            _formik.Form,
	            { noValidate: true },
	            _react2.default.createElement(
	              _Typography2.default,
	              {
	                type: "heading6",
	                style: {
	                  textAlign: "center",
	                  marginBottom: "32px",
	                  color: "#888f96"
	                }
	              },
	              "We\u2019re here to help you succeed during (and after) this market shift."
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: classes.topRow },
	              _react2.default.createElement(_formik.Field, {
	                id: "firstname",
	                name: "firstname",
	                label: "First Name",
	                component: _Input2.default,
	                className: classes.field
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "lastname",
	                name: "lastname",
	                label: "Last Name",
	                component: _Input2.default,
	                className: classes.field
	              })
	            ),
	            _react2.default.createElement(_formik.Field, {
	              id: "email",
	              name: "email",
	              label: "Email",
	              component: _Input2.default,
	              className: classes.field
	            }),
	            _react2.default.createElement(_formik.Field, {
	              id: "phone",
	              name: "phone",
	              label: "Phone",
	              component: _Input2.default,
	              className: classes.field,
	              type: "tel"
	            }),
	            _react2.default.createElement(_formik.Field, {
	              id: "company",
	              name: "company",
	              label: "Affiliation (optional)",
	              component: _Input2.default,
	              className: classes.field
	            }),
	            _react2.default.createElement(_formik.Field, {
	              id: "mls_number",
	              name: "mls_number",
	              label: "MLS # (optional)",
	              component: _Input2.default,
	              className: classes.field
	            }),
	            _react2.default.createElement(_formik.Field, {
	              id: "role",
	              name: "role",
	              label: "I am a(n)",
	              component: _RadioGroup2.default,
	              display: "inline",
	              items: [{
	                label: "Existing client – looking to connect to review my account & make sure I’m doing everything I can!",
	                value: "Existing Client"
	              }, {
	                label: "An agent – looking to schedule my 15-minute online marketing evaluation.",
	                value: "Agent"
	              }, {
	                label: "A broker – interested in scheduling my gap analysis.",
	                value: "Broker"
	              }, {
	                label: "Other (please specify)*",
	                value: "Other"
	              }],
	              className: classes.field
	            }),
	            values.role === "Other" && _react2.default.createElement(_formik.Field, {
	              id: "roleOther",
	              name: "roleOther",
	              label: "Other",
	              component: _Input2.default,
	              className: classes.field,
	              autoFocus: true
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                type: "submit",
	                className: classes.signUpBtn,
	                disabled: isSubmitting
	              },
	              "Please contact me asap"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { fontSize: "11px", textAlign: "center" } },
	              "By submitting this form, you are requesting to be contacted by a member of the Elevate Sales Team at the details provided via text, email or call (may involve automated or pre-recorded means). You may revoke this consent through any reasonable means."
	            )
	          );
	        }
	      })
	    );
	  };
	
	  return SignUpFormCovid;
	}(_react.Component);
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      maxWidth: "600px",
	      backgroundColor: "#f7f7f7 !important",
	      margin: "0 auto"
	    },
	    link: {
	      color: "inherit"
	    },
	    field: {
	      borderRadius: "6px",
	      border: "2px solid #ECECEC",
	      height: "50px",
	      fontWeight: "600"
	    },
	    topRow: {
	      display: "flex",
	      flexDirection: "row",
	      justifyContent: "space-between",
	
	      "& > * + *": {
	        marginLeft: "12px"
	      }
	    },
	    signUpBtn: {
	      width: "100%",
	      fontSize: "20px",
	      lineHeight: "26px",
	      fontWeight: "600",
	      color: "#FFF",
	      backgroundColor: theme.colors.secondary,
	      borderRadius: "6px",
	      padding: "12px",
	      margin: "14px 0"
	    },
	    selectfield: {
	      borderRadius: "6px",
	      border: "2px solid #ECECEC",
	      height: "40px"
	    },
	    selectlabel: {
	      width: "100%",
	      color: "#888f96",
	      display: "flex",
	      fontSize: "14px",
	      alignItems: "center",
	      lineHeight: "18px",
	      fontWeight: "700",
	      marginBottom: "4px"
	    }
	  };
	})(SignUpFormCovid);
	module.exports = exports["default"];

/***/ }),

/***/ 3064:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/covid_c1.927ee22b.png";

/***/ }),

/***/ 3065:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/covid_c2.62cee87f.png";

/***/ }),

/***/ 3066:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/covid_c3.2dcb5d8c.png";

/***/ }),

/***/ 3067:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/covid_c4.5d93873f.png";

/***/ }),

/***/ 3068:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/covid_logo.66bee9c3.png";

/***/ }),

/***/ 1664:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _siteConfig = __webpack_require__(7);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _SignUpFormCovid = __webpack_require__(1615);
	
	var _SignUpFormCovid2 = _interopRequireDefault(_SignUpFormCovid);
	
	var _covid_header = __webpack_require__(48);
	
	var _covid_header2 = _interopRequireDefault(_covid_header);
	
	var _covid_logo = __webpack_require__(3068);
	
	var _covid_logo2 = _interopRequireDefault(_covid_logo);
	
	var _covid_c = __webpack_require__(3064);
	
	var _covid_c2 = _interopRequireDefault(_covid_c);
	
	var _covid_c3 = __webpack_require__(3065);
	
	var _covid_c4 = _interopRequireDefault(_covid_c3);
	
	var _covid_c5 = __webpack_require__(3066);
	
	var _covid_c6 = _interopRequireDefault(_covid_c5);
	
	var _covid_c7 = __webpack_require__(3067);
	
	var _covid_c8 = _interopRequireDefault(_covid_c7);
	
	var _SEO = __webpack_require__(6);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Covidshift = function Covidshift(_ref) {
	  var children = _ref.children,
	      classes = _ref.classes,
	      data = _ref.data,
	      tags = _ref.tags;
	
	  var postNode = {
	    title: "Success Story - " + _siteConfig2.default.siteTitle
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes.root },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        "title",
	        null,
	        "Covidshift - " + _siteConfig2.default.siteTitle
	      )
	    ),
	    _react2.default.createElement(_SEO2.default, { postNode: postNode, pagePath: "Covidshift" }),
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(
	        "div",
	        { style: { paddingBottom: "50px", textAlign: "center" } },
	        _react2.default.createElement("img", { src: _covid_logo2.default, width: "345", style: { paddingBottom: "20px" } }),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "h1",
	          { className: classes.heading },
	          "Stream The Webinar"
	        ),
	        _react2.default.createElement(
	          "h2",
	          { className: classes.subHeading },
	          "Missed the webinar or looking for a replay? We\u2019ve got you covered."
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { textAlign: "center", maxWidth: "700px", marginLeft: "auto", marginRight: "auto", paddingBottom: "50px" } },
	          _react2.default.createElement(
	            "div",
	            { style: { textAlign: "center" }, className: classes.videoEmbed },
	            _react2.default.createElement("iframe", { className: classes.videoContainer, src: "https://www.youtube.com/embed/g92eC1CVAYs",
	              frameborder: "0", allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowfullscreen: true })
	          )
	        ),
	        _react2.default.createElement(
	          "h1",
	          { className: classes.heading },
	          "Poll Results"
	        ),
	        _react2.default.createElement(
	          "h2",
	          { className: classes.subHeading },
	          "Participated in our live survey?  Here\u2019s the group results."
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: classes.top },
	          _react2.default.createElement(
	            "div",
	            { className: classes.column3, style: { textAlign: "center", paddingTop: "12px" } },
	            _react2.default.createElement(
	              "div",
	              { style: { textAlign: "center", paddingTop: "12px" } },
	              _react2.default.createElement(
	                "h2",
	                { className: classes.subHeading },
	                "Real estate professionals are forecasting a serious market shift.",
	                _react2.default.createElement("br", null),
	                "Do you believe this is happening",
	                _react2.default.createElement("br", null),
	                "right now?"
	              ),
	              _react2.default.createElement("img", { src: _covid_c2.default, width: "255" })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.column3, style: { textAlign: "center", paddingTop: "12px" } },
	            _react2.default.createElement(
	              "div",
	              { style: { textAlign: "center", paddingTop: "12px" } },
	              _react2.default.createElement(
	                "h2",
	                { className: classes.subHeading },
	                "If YES...",
	                _react2.default.createElement("br", null),
	                "how long do you think this",
	                _react2.default.createElement("br", null),
	                "real estate market shift will last?"
	              ),
	              _react2.default.createElement("img", { src: _covid_c4.default, width: "255" })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: classes.column3, style: { textAlign: "center", paddingTop: "12px" } },
	            _react2.default.createElement(
	              "div",
	              { style: { textAlign: "center", paddingTop: "12px" } },
	              _react2.default.createElement(
	                "h2",
	                { className: classes.subHeading },
	                "Are you currently investing MORE in your lead generation and marketing efforts, OR are you withdrawing / holding back?"
	              ),
	              _react2.default.createElement("img", { src: _covid_c8.default, width: "255" })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { textAlign: "center", paddingTop: "32px" } },
	          _react2.default.createElement(
	            "h2",
	            { className: classes.subHeading },
	            "How are you staying in touch",
	            _react2.default.createElement("br", null),
	            "with your clients?"
	          ),
	          _react2.default.createElement("img", { src: _covid_c6.default, width: "355" }),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "h2",
	            { className: classes.subHeading },
	            _react2.default.createElement(
	              "span",
	              { className: classes.bold, style: { color: "#55c3ba" } },
	              "69% Email"
	            ),
	            " (Mass mailing, one-on-one, etc.)",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "span",
	              { className: classes.bold, style: { color: "#55c3ba" } },
	              "59% Social Media"
	            ),
	            " (Facebook, Twitter, Instagram, LinkedIn, etc.)",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "span",
	              { className: classes.bold, style: { color: "#55c3ba" } },
	              "17% Video Meetings / House Tours"
	            ),
	            " (FaceTime, Zoom, GoToMeeting, etc.)"
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { backgroundColor: "#f7f7f7", paddingBottom: "50px" } },
	      _react2.default.createElement(
	        "h1",
	        { className: classes.heading, style: { paddingTop: "50px" } },
	        "Connect with a Success Coach"
	      ),
	      _react2.default.createElement(_SignUpFormCovid2.default, null)
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      padding: "0 0px",
	      margin: "40px auto"
	    },
	    heading: {
	      fontSize: "28px",
	      fontWeight: "700",
	      letterSpacing: ".14px",
	      color: "#55c3ba",
	      textAlign: "center",
	      marginBottom: "12px"
	    },
	    top: {
	      display: "flex",
	      flexWrap: "wrap",
	      alignItems: "top"
	    },
	
	    bold: {
	      fontWeight: "700"
	    },
	
	    column3: {
	      width: "350px",
	      maxWidth: "100%",
	      paddingRight: "10px",
	      paddingLeft: "10px",
	      verticalAlign: "top"
	    },
	
	    column2: {
	      width: "470px",
	      maxWidth: "100%",
	      paddingRight: "10px",
	      paddingLeft: "10px",
	      verticalAlign: "top"
	    },
	
	    subHeading: {
	      fontSize: "18px",
	      lineHeight: "28px",
	      fontWeight: "600",
	      letterSpacing: ".08px",
	      color: "#888f96",
	      textAlign: "center",
	      margin: "0 auto 36px"
	    },
	
	    covidContainer: {
	      width: "70%",
	      margin: "16px auto 0 auto"
	    },
	    covidHeader: {
	      width: "100%"
	    },
	
	    videoEmbed: {
	      position: "relative",
	      paddingBottom: "56.25%",
	      paddingTop: "30px",
	      height: "0",
	      overflow: "hidden"
	
	    },
	    videoContainer: {
	      position: "absolute",
	      top: "0",
	      left: "0",
	      width: "100%",
	      height: "100%"
	      // closingContainer: {
	      //   color: "#A9A8B6",
	      //   fontWeight: "600",
	      //   fontSize: "18px",
	      //   textAlign: "center",
	      //   margin: "60px auto 0",
	      // },
	      // emailLink: {
	      //   color: "#2E2E35 !important",
	      //   textDecoration: "underline",
	
	      //   "&:hover": {
	      //     textDecoration: "none !important",
	      //   },
	      // },
	    } };
	})(Covidshift);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-covidshift-js-b56521a1a442794b7e22.js